class NotificationModal {
	constructor($timeout, $rootScope, $templateCache) {
		const templateString = $templateCache.get('templates/notification-modal-tmpl.html');

		this.$timeout = $timeout;
		this.$rootScope = $rootScope;

		this.restrict = 'EA';
		this.scope = {
			message: '=',
			showNotificationModal: '=',
			shouldCloseOnClick: '@?shouldCloseOnClick'
		};
		this.link = this.NotificationModalLink;
		this.template = templateString;

		this.animationPromise = undefined;
	}

	NotificationModalLink(scope, element, attrs) {
		const $element = $($(element).get(0));
		const $modalBackground = $element.parent();
		const $iconElement = $($('.fa', $element).get(0));

		let shouldCloseOnClick = false;

		if (attrs.shouldCloseOnClick) {
			shouldCloseOnClick = JSON.parse(attrs.shouldCloseOnClick);
		}
		if (shouldCloseOnClick) {
			$modalBackground.on('click', () => {
				$modalBackground.slideUp('280');
			});
		}

		this.$rootScope.$on('notifications-modal-show', ($event, data) => {
			const { message, error, timeout } = data;
			if (!$event.defaultPrevented) {
				$event.defaultPrevented = true;
			}
			if (message) {
				scope.showNotificationModal(message, error, timeout);
			}
		});

		scope.showNotificationModal = (msg, err, timeoutPeriod) => {
			this.$timeout(() => {
				if (msg) {
					scope.message = msg;
				}

				if (err) {
					if ($iconElement.hasClass('fa-check-circle')) {
						$iconElement.removeClass('fa-check-circle');
					}
					$iconElement.addClass('fa-times-circle');
				} else {
					if ($iconElement.hasClass('fa-times-circle')) {
						$iconElement.removeClass('fa-times-circle');
					}
					$iconElement.addClass('fa-check-circle');
				}
				$modalBackground.animate(
					{
						height: 'toggle'
					},
					{
						duration: 600,
						specialEasing: {
							width: 'linear',
							height: 'easeInOutExpo' //"easeOutBack"//"easeOutQuart"
						},
						complete: () => {},
						done: () => {
							if (!this.animationPromise) {
								this.animationPromise = this.$timeout(() => {
									$modalBackground.slideUp('280');
								}, timeoutPeriod);

								this.animationPromise.then(() => {
									//this.$timeout.cancel(this.animationPromise);
									this.animationPromise = undefined;
								});
							}
						}
					}
				);
			});
		};
	}
}

export default /* @ngInject */ ($timeout, $rootScope, $templateCache) =>
	new NotificationModal($timeout, $rootScope, $templateCache);
